import { render, staticRenderFns } from "./BaseSendMessage.vue?vue&type=template&id=7ce1b83d&"
import script from "./BaseSendMessage.vue?vue&type=script&lang=ts&"
export * from "./BaseSendMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports